import {Injectable, OnDestroy} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot} from '@angular/router';
import {MessageService} from '../message.service';
import {IPlayer} from '../../vo/interfaces';

@Injectable({providedIn: 'root'})
export class PlayerResolver implements Resolve<any>, OnDestroy {
    // Error message to display in error popup
    error: string;
    dataService: any;
    player: IPlayer;
    name: string;
    postponedPath: string;

    constructor(public message: MessageService) {
    }

    ngOnDestroy(): void {
        this.dataService = null;
        this.player = null;
    }

    resolve(route: ActivatedRouteSnapshot): PlayerResolver {
        return this;
    }
}
